
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/page/[...id]",
      function () {
        return require("private-next-pages/blog/page/[...id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/page/[...id]"])
      });
    }
  